import {
  languageBuilder
} from "./builder.js";
const anime_airing = {
  UNIT_SINGULAR: `seria`,
  UNIT_PLURAL: `serie`,
  UNIT_SHORT: `Seria`,
  SUBUNIT_SINGULAR: `odcinek`,
  SUBUNIT_PLURAL: `odcinki`,
  SUBUNIT_SHORT: `Odc.`,
  SUBUNIT_VERB_FUTURE: `wychodzi`,
  SUBUNIT_VERB_PAST: `wyszed\u0142`
};
const anime_bluray = {
  UNIT_SINGULAR: `seria`,
  UNIT_PLURAL: `serie`,
  UNIT_SHORT: `Seria`,
  SUBUNIT_SINGULAR: `p\u0142yta`,
  SUBUNIT_PLURAL: `p\u0142yty`,
  SUBUNIT_SHORT: `P\u0142yta`,
  SUBUNIT_VERB_FUTURE: `wychodzi`,
  SUBUNIT_VERB_PAST: `wyszed\u0142`
};
const manga_chapter = {
  UNIT_SINGULAR: `manga`,
  UNIT_PLURAL: `mangi`,
  UNIT_SHORT: `Manga`,
  SUBUNIT_SINGULAR: `rozdzia\u0142`,
  SUBUNIT_PLURAL: `rozdzia\u0142y`,
  SUBUNIT_SHORT: `Roz.`,
  SUBUNIT_VERB_FUTURE: `wychodzi`,
  SUBUNIT_VERB_PAST: `wyszed\u0142`
};
const manga_volume = {
  UNIT_SINGULAR: `manga`,
  UNIT_PLURAL: `manga`,
  UNIT_SHORT: `Manga`,
  SUBUNIT_SINGULAR: `tom`,
  SUBUNIT_PLURAL: `tomy`,
  SUBUNIT_SHORT: `Tom`,
  SUBUNIT_VERB_FUTURE: `wychodzi`,
  SUBUNIT_VERB_PAST: `wyszed\u0142`
};
const strings = {
  ALL_COMPLETE: `Wszystkie projekty uko\u0144czone!`,
  CONNECTION_ERROR: `B\u0142\u0105d po\u0142\u0105czenia`,
  CONFIG_HEADER: `Konfiguracja`,
  WEBSITE_SETTINGS_HEADER: `Ustawienia strony`,
  APP_URL: `Adres twojej aplikacji`,
  LINK_PAGE: `Id\u017A do strony`,
  PAGE_BGCOLOR: `G\u0142\xF3wny kolor t\u0142a`,
  NO_COLOR: `Ignoruj kolor t\u0142a`,
  RECOMMENDED_BGCOLOR: `Rekomendowany kolor t\u0142a`,
  OVERRIDE_BGCOLOR: `Ignoruj rekomendowany kolor t\u0142a`,
  THEME_HEADER: `Motyw`,
  THEME_LIGHT: `Jasny`,
  THEME_DARK: `Ciemny`,
  SIZE_HEADER: `Rozmiar`,
  SIZE_SMALL: `Ma\u0142y (niepolecany)`,
  SIZE_NORMAL: `Normalny`,
  ACCENT_HEADER: `Kolor akcentu`,
  ACCENT_RED: `Czerwony`,
  ACCENT_YELLOW: `\u017B\xF3\u0142ty`,
  ACCENT_GREEN: `Zielony`,
  ACCENT_BLUE: `Niebieski`,
  ACCENT_INDIGO: `Indygo`,
  ACCENT_PURPLE: `Fioletowy`,
  ACCENT_PINK: `R\xF3\u017Cowy`,
  ACCENT_NONE: `Brak`,
  LANGUAGE_HEADER: `J\u0119zyk`,
  EMBED_HEADER: `Kod do osadzenia w Wordpressie`,
  EMBED_DESCRIPTION: `Zmie\u0144 rozmiar iframe po za\u0142adowaniu strony`,
  EMBED_SHOW: `Poka\u017C kod`,
  EMBED_HIDE: `Ukryj kod`,
  ALL_POSITIONS: `Wszystkie role`,
  UNIT_JOINT_WITH: `Wsp\xF3lnie z {0}`,
  UNIT_SHOW_LESS: `Poka\u017C mniej`,
  UNIT_SHOW_LESS_PLURAL: void 0,
  UNIT_SHOW_REMAINDER_SINGULAR: `Poka\u017C wi\u0119cej...`,
  UNIT_SHOW_REMAINDER_PLURAL: `Poka\u017C wi\u0119cej...`,
  UNIT_UPDATED: `Zaktualizowano {2}`,
  SUBUNIT_NOT_PUBLISHED: `%SUBUNIT_SHORT% {0} %SUBUNIT_VERB_FUTURE% {1}`,
  SUBUNIT_WAS_PUBLISHED: `%SUBUNIT_SHORT% {0} %SUBUNIT_VERB_PAST% {1}`,
  SUBUNIT_TO_RELEASE: `%SUBUNIT_SHORT% {0} gotowy`,
  SUBUNIT_IN_PROGRESS: `%SUBUNIT_SHORT% {0} wymaga {2}`,
  SUBUNIT_NO_PROGRESS: `(nierozpocz\u0119ty)`
};
import pl from "../../_snowpack/pkg/javascript-time-ago/locale/pl.json.proxy.js";
const lang = {
  locale: pl,
  strings
};
export default {
  anime_airing: languageBuilder(lang, anime_airing),
  anime_bluray: languageBuilder(lang, anime_bluray),
  manga_chapter: languageBuilder(lang, manga_chapter),
  manga_volume: languageBuilder(lang, manga_volume)
};
//# sourceMappingURL=pl.js.map
